export const percentChange = (currVal: number, prevVal: number): number => Math.abs(currVal - prevVal) / prevVal;

export const withinPercentTolerance = (currVal: number, prevVal: number, tolerance: number): boolean =>
  percentChange(currVal, prevVal) <= tolerance;

export const roundToDecimal = (num: number, decimalPlaces: number): number => {
  const multiplier = Math.pow(10, decimalPlaces);
  return Math.round(num * multiplier) / multiplier;
};
